define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"SiteAdmin/ToolbarPluginLocale"
], function(declare, _, ToolbarPluginLocale) {

	return declare(ToolbarPluginLocale, {
		/**
		 * @override
		 * Plugin is valid if target class of view has an enabled LocalizedName attribute that is of Localized format
		 */
		validatePlugin: function(ctx) {
			const rc = ctx.defView.getPageClass();
			return !!rc?.isLocalizedItem;
		},

		_postActionLocale: function() {
			// summary: remove any filters for localized names in view query
			var view = this.getView();
			var oldQuery = view.get("query");
			var keysToRemove = [];

			_.each(oldQuery, function(value, key) {
				var spec = view.getSpec(key);
				if (spec && spec.isLocalizedAttribute()) {
					keysToRemove.push(key);
				}
			});

			if (keysToRemove) {
				_.each(keysToRemove, function(key) {
					view.setQueryValue(key, null);
				});
			}

			// refresh view - this must be done to properly reset drop-down filter stores and querySpecStore
			view.refreshWidget();
		}
	});
});